import React, { useState } from "react";
import sampleProfile from "../../Assets/Images/avator.png";
import "./style.scss";
import { LuCircle } from "react-icons/lu";
import ImageModal from "Components/ImageModal";
import PDFIcom from "../../Assets/Images/pdfImg.png";
import DocIcon from "../../Assets/Images/doc.png";
import XlsIcon from "../../Assets/Images/xlsx.png";
import { FileUploader } from "react-drag-drop-files";
import DragandDrop from "../../Assets/Svg/Auth/DragandDrop.svg";
import { compressImage } from "Services/Utils/imageCompression";
import ReactQuill from "react-quill-new";
import "quill/dist/quill.snow.css";
import { multiUpload } from "../../Redux/Slices/User/userSlice";
import { MdDeleteOutline } from "react-icons/md";

const ApprovalAnswer = ({
  categories,
  categoryIndex,
  subCategoryIndex,
  feedback,
  setFeedback,
  questionId,
  approverMediaFiles,
  setApproverMediaFiles,
  dispatch,
  researchData,
  recommendationData,
}) => {
  const [hoveredRatingForModule, setHoveredRatingForModule] = useState(null);
  const isAdditionalInsights =
    subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 2;

  const isLastSubCategory =
    subCategoryIndex === categories[categoryIndex]?.sub_categories?.length - 1;

  const additionalInsightsData =
    categories[categoryIndex]?.sub_categories[subCategoryIndex]
      ?.additionalInsightsData;

  const feedbackData = categories[categoryIndex]?.sub_categories[subCategoryIndex]?.feedbackData

  const validAdditionalInsights = additionalInsightsData?.filter((item) => item?.comments?.trim()?.length > 0 || item?.mediaFiles?.length > 0) || []
  const validFeedbackData = feedbackData?.filter((item) => item?.comments?.trim()?.length > 0 || (item?.rating ?? 0) > 0) || []
  console.log(researchData, recommendationData);

  const getAnswerText = (list) => {
    return [
      list?.subOption ? `${list?.subOption?.title} :` : "",
      list?.options?.title || "",
      list?.text_answer || "",
    ].filter(Boolean).join(" ");
  };

  const getGreaseInfo = (list) => {
    return list?.grease_name || list?.grease_size || "";
  };

  const handleFileChange = async (files, questionId) => {
    const formData = new FormData();
    let isValid = true;
    const compressedFiles = [];

    for (const file of Array.from(files)) {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];

      if (!allowedTypes.includes(file.type)) {
        // Set error message
        isValid = false;
        break;
      }

      let finalFile = file;

      if (file.type.startsWith("image/") && file.size > 1024 * 1024 && file.size < 5 * 1024 * 1024) {
        try {
          const compressedBlob = await compressImage(file, 1);
          finalFile = new File([compressedBlob], file.name, {
            type: compressedBlob.type,
            lastModified: Date.now(),
          });
        } catch (err) {
          isValid = false;
          break;
        }
      }

      if (file.size > 5 * 1024 * 1024) {
        isValid = false;
        break;
      }

      compressedFiles.push(finalFile);
    }

    if (!isValid) return;

    compressedFiles.forEach(file => {
      formData.append("files", file);
    });

    const onUploadSuccess = (uploadedFiles) => {
      const currentFiles = approverMediaFiles[questionId] || [];
      const newFiles = uploadedFiles.map((file) => ({
        name: file.originalName,
        url: file.url,
      }));

      setApproverMediaFiles(prev => ({
        ...prev,
        [questionId]: [...currentFiles, ...newFiles]
      }));
    };

    dispatch(
      multiUpload({
        files: formData,
        callBack: onUploadSuccess,
      })
    );
  };

  const handleRemoveFile = (fileUrl, questionId) => {
    setApproverMediaFiles(prev => ({
      ...prev,
      [questionId]: (prev[questionId] || []).filter(file => file.url !== fileUrl)
    }));
  };

  return (
    <div className="p-3">
      <div className="assessmentReviewAnsWrap">
        {isAdditionalInsights ? (
          <>
            <div className="assessmentReviewQuestion">Additional insights</div>
            <div className="mt-3">
              {validAdditionalInsights?.length > 0 ? (
                <>
                  {validAdditionalInsights?.map((item) => {
                    return (
                      <div className="additionalContentWrap my-3">
                        <div className="d-flex align-items-center mt-2 mb-3">
                          {item?.user?.profile_image ? (
                            <img
                              src={item?.user?.profileImage}
                              alt={item?.userName}
                            />
                          ) : (
                            <img
                              src={sampleProfile}
                              alt="profile"
                              className="reviewProfileImage"
                            />
                          )}
                          <div className="answeredMemberName mx-3">
                            {item?.userName}
                          </div>
                        </div>
                        <div>
                          <div className="additionalTitle">Media files</div>
                          {item?.mediaFiles?.length > 0 ? (
                            <div className="mediaFilesWrap">
                              {item?.mediaFiles?.map((list) => {
                                const isPDF = list.toLowerCase().endsWith(".pdf");
                                const isDoc = list.toLowerCase().endsWith(".docx");
                                const isXls = list.toLowerCase().endsWith(".xlsx");
                                return (
                                  <div key={list} className="my-2">
                                    {isPDF ? (
                                      <div className="pdf-container">
                                        <div className="individual-pdf-container">
                                          <a href={list} target="_blank" rel="noopener noreferrer">
                                            <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                            <p>Open PDF</p>
                                          </a>
                                        </div>
                                      </div>
                                    ) : isDoc ? (
                                      <div className="pdf-container">
                                        <div className="individual-pdf-container">
                                          <a href={list} target="_blank" rel="noopener noreferrer">
                                            <img src={DocIcon} alt="Doc" width="75px" height="auto" />
                                            <p>Open Doc</p>
                                          </a>
                                        </div>
                                      </div>
                                    ) : isXls ? (
                                      <div className="pdf-container">
                                        <div className="individual-pdf-container">
                                          <a href={list} target="_blank" rel="noopener noreferrer">
                                            <img src={XlsIcon} alt="Xlsx" width="75px" height="auto" />
                                            <p>Open Xlsx</p>
                                          </a>
                                        </div>
                                      </div>
                                    ) : (
                                      <ImageModal src={list} alt={`file-${list}`} />
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div>
                          <label className="additionalTitle">Comments</label>
                          <div className="additionalComments">
                            {item?.comments ?? ""}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div>No Additional insights</div>
              )}
            </div>
          </>
        ) : isLastSubCategory ? (
          <>
            <div className="assessmentReviewQuestion">Feedback</div>
            <div>
              {validFeedbackData?.length > 0 ? (
                <>
                  {validFeedbackData?.map((item) => {
                    return (
                      <div className="additionalContentWrap my-3">
                        <div className="d-flex align-items-center mt-2 mb-3">
                          {item?.user?.profile_image ? (
                            <img
                              src={item?.user?.profileImage}
                              alt={item?.userName}
                            />
                          ) : (
                            <img
                              src={sampleProfile}
                              alt="profile"
                              className="reviewProfileImage"
                            />
                          )}
                          <div className="answeredMemberName mx-3">
                            {item?.userName}
                          </div>
                        </div>
                        <label className="additionalTitle">Comments</label>
                        <ReactQuill
                          theme="snow"
                          value={item?.comments || ""}
                          readOnly={true}
                          placeholder="Enter your feedback here..."
                          className="styled-quill-editor"
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, 3, false] }],
                              ["bold", "italic", "underline"],
                              [{ list: "ordered" }, { list: "bullet" }],
                              ["clean"],
                            ],
                          }}
                          formats={[
                            "header",
                            "bold",
                            "italic",
                            "underline",
                            "list",
                            "bullet",
                          ]}
                        />

                        {/* ADD THIS SECTION */}
                        {/* <div className="mt-3">
                            <label className="addLabel mb-2">Upload Supporting Documents</label>
                            <FileUploader
                              multiple
                              name="approverMediaFiles"
                              classes="drop_area drop_zone"
                              handleChange={(files) => handleFileChange(files, item?.question_id)}
                            >
                              <p className="drag">
                                <span className="mx-2 my-1">
                                  <img src={DragandDrop} alt="upload" />
                                </span>
                                Drag your file here or upload to{" "}
                                <span className="here mx-2">browse</span>
                              </p>
                            </FileUploader>
                            <div className="my-2 uploadNote">
                              Note: Only images (JPG, JPEG, PNG), PDFs, word documents (DOCX), and excel files (XLSX) are allowed. File size must not exceed 5MB.
                            </div>
                            
                            <div className="uploaded-files mt-2">
                              {(approverMediaFiles[item?.question_id] || []).map((file, index) => (
                                <div key={index} className="file-item">
                                  <span className="me-2">{file.name}</span>
                                  <MdDeleteOutline
                                    onClick={() => handleRemoveFile(file.url, item?.question_id)}
                                    color="#1f2155"
                                    size={25}
                                    className="remove-icon"
                                  />
                                </div>
                              ))}
                            </div>
                          </div> */}
                        <div>
                          <label className="additionalTitle">Ratings</label>
                          <div className="additionalComments">
                            <div className="star-rating">
                              {[1, 2, 3, 4, 5].map(star => (
                                <span
                                  key={star}
                                  className={`star ${hoveredRatingForModule !== null
                                    ? star <= hoveredRatingForModule ? "hovered" : ""
                                    : star <= (item?.rating || 0) ? "filled" : ""
                                    }`}
                                  onMouseLeave={() => setHoveredRatingForModule(null)}
                                  disabled={true}
                                >
                                  ★
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div>No Feedback Added</div>
              )}
            </div>
          </>
        ) :
          (
            <>
              {categories[categoryIndex]?.sub_categories[
                subCategoryIndex
              ]?.questions?.map((item, questionIndex) => {
                const lastOccurrenceMap = new Map();
                item?.userAnswer?.forEach((item, index) => {
                  lastOccurrenceMap.set(item.user_id, index);
                });
                return (
                  <div key={questionIndex}>
                    <div className="assessmentReviewQuestion">
                      {item?.question_id}. <span>{item?.question}</span>
                    </div>
                    <div className="assessmentReviewAnswer">
                      <div className="assessmentAnswerWrap mt-4">
                        {item?.userAnswer?.length > 0 ? (
                          <>
                            {item?.userAnswer?.map((items, answerIndex) => {

                              const isLastOccurrence =
                                lastOccurrenceMap.get(items.user_id) === answerIndex;

                              return (<div key={answerIndex}>
                                <div className="d-flex align-items-center my-2">
                                  {items?.user?.profile_image ? (
                                    <img
                                      src={items?.user?.profile_image}
                                      alt={items?.user_name}
                                      className="reviewProfileImage"
                                    />
                                  ) : (
                                    <img
                                      src={sampleProfile}
                                      alt="profile"
                                      className="reviewProfileImage"
                                    />
                                  )}
                                  <div className="answeredMemberName mx-4">
                                    {items?.user_name}
                                  </div>
                                  <div className="answeredMemberName">
                                    {items?.points}
                                  </div>
                                </div>
                                {items?.bearing_size && (
                                  <>
                                    {/* <div className="answeredMemberName">
                                      Bearing Size
                                    </div> */}
                                    <div>{items?.bearing_size}  ({items?.bearing_size === 'small' ? '<55mm' : items?.bearing_size === 'medium' ? '55mm - 200mm' : '>200mm'})</div>
                                  </>
                                )}
                                <div style={{ color: item?.field_type === "rearrange" ? items?.points === 1 ? "#5df380" : "#e94f45" : "" }}>
                                  {getGreaseInfo(items) ? (
                                    <>
                                      {getAnswerText(items)}
                                      <br />
                                      {getGreaseInfo(items)}
                                    </>
                                  ) : (
                                    getAnswerText(items)
                                  )}
                                </div>
                                {isLastOccurrence && (
                                  <>
                                    <div className="answeredMemberName my-2">
                                      Notes
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: items?.notes }} />
                                  </>
                                )}
                              </div>
                              )
                            })}
                          </>
                        ) : (
                          <>
                            <div
                              className="d-flex align-items-center">
                              <span className="message">No Answer</span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="assessmentReviewAnswer">
                      <div className="assessmentAnswerWrap mt-4">
                        <div className="addLabel">Assessor Input</div>
                        <div className="mt-2">
                          <div className="detailsLabel">Observation</div>
                          <div className="fs-18 fw-400 mt-2 allText" dangerouslySetInnerHTML={{ __html: item?.observation }} />
                        </div>
                        <div className="my-3">
                          <div className="detailsLabel">Assessment References</div>
                          <div className="d-flex flex-wrap align-items-center my-2" style={{ gap: "20px" }}>
                            {Array.isArray(researchData?.[0]?.upload) &&
                              researchData[0].upload.length > 0 ? (
                              researchData[0].upload.map((evidence, index) => (
                                <div key={index}>
                                  {/* FILES */}
                                  {Array.isArray(evidence.image_url) &&
                                    evidence.image_url.map((fileUrl, i) => {
                                      const lower = fileUrl.toLowerCase();

                                      if (lower.endsWith(".pdf")) {
                                        return (
                                          <div key={i} className="pdf-container">
                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                              <img src={PDFIcom} width="75px" alt="PDF" />
                                              <p>Open PDF</p>
                                            </a>
                                          </div>
                                        );
                                      }

                                      if (lower.endsWith(".docx")) {
                                        return (
                                          <div key={i} className="pdf-container">
                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                              <img src={DocIcon} width="75px" alt="Doc" />
                                              <p>Open Doc</p>
                                            </a>
                                          </div>
                                        );
                                      }

                                      if (lower.endsWith(".xlsx")) {
                                        return (
                                          <div key={i} className="pdf-container">
                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                              <img src={XlsIcon} width="75px" alt="Xlsx" />
                                              <p>Open Xlsx</p>
                                            </a>
                                          </div>
                                        );
                                      }

                                      return <ImageModal key={i} src={fileUrl} alt={`evidence-${i}`} />;
                                    })}

                                  {/* TEXT */}
                                  {evidence.text && (
                                    <div
                                      className="fs-16 fw-400 mt-1 remove-bg allText"
                                      dangerouslySetInnerHTML={{ __html: evidence.text }}
                                    />
                                  )}
                                </div>
                              ))
                            ) : (
                              "No assessment references found"
                            )}
                          </div>

                        </div>
                        <div>
                          <div className="detailsLabel">Insights</div>
                          <div className="fs-18 fw-400 mt-2 allText" dangerouslySetInnerHTML={{ __html: item?.insights }} />                      </div>
                      </div>
                    </div>
                    <div className="assessmentReviewAnswer">
                      <div className="assessmentAnswerWrap mt-4">
                        <div className="addLabel">Recommendations</div>
                        <div>
                          {recommendationData?.length > 0 ? (
                            // item.recommendation.map((rec, index) => (
                            recommendationData.map((rec, index) => (
                              <div key={index} className="my-2" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                {/* Show image/media first */}
                                {Array.isArray(rec.image_url) &&
                                  rec.image_url.map((fileUrl, i) => {
                                    const lower = fileUrl.toLowerCase();

                                    if (lower.endsWith(".pdf")) {
                                      return (
                                        <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                          <img src={PDFIcom} width="75px" alt="PDF" />
                                          <p>Open PDF</p>
                                        </a>
                                      );
                                    }

                                    return <ImageModal key={i} src={fileUrl} alt={`rec-${i}`} />;
                                  })}


                                {/* Then show text */}
                                {rec.message && (
                                  <div className="p-1 allText" dangerouslySetInnerHTML={{ __html: rec.message }} />
                                )}
                              </div>
                            ))
                          ) : (
                            <div>No Recommendations</div>
                          )}
                        </div>

                      </div>
                    </div>
                    <div className="assessmentReviewAnswer">
                      <div className="assessmentAnswerWrap mt-4">
                        <div className="addLabel">Final Score</div>
                        <div className="finalScoreLabel">{item?.finalScore}</div>
                      </div>
                    </div>
                    {((researchData?.length ?? 0) > 0 || (recommendationData?.length ?? 0) > 0) && (
                      <div className="mt-4">
                        <label className="addLabel mb-2">Approver Feedback</label>
                        <ReactQuill
                          theme="snow"
                          value={questionId === item?.question_id ? feedback : ""}
                          onChange={setFeedback}
                          placeholder="Enter your feedback here..."
                          className="styled-quill-editor"
                          readOnly={item?.userAnswer?.length > 0 ? false : true}
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, 3, false] }],
                              ["bold", "italic", "underline"],
                              [{ list: "ordered" }, { list: "bullet" }],
                              ["clean"],
                            ],
                          }}
                          formats={[
                            "header",
                            "bold",
                            "italic",
                            "underline",
                            "list",
                            "bullet",
                          ]}
                        />

                        <div className="mt-3">
                          <label className="addLabel mb-0">Upload Supporting Documents</label>
                          <div className="filess">
                            <FileUploader
                              multiple
                              name="approverMediaFiles"
                              classes="drop_area drop_zone"
                              handleChange={(files) => handleFileChange(files, item?.question_id)}
                            >
                              <p className="drag">
                                <span className="mx-2 my-1">
                                  <img src={DragandDrop} alt="upload" />
                                </span>
                                Drag your file here or upload to{" "}
                                <span className="here mx-2">browse</span>
                              </p>
                            </FileUploader>
                          </div>
                          <div className="my-2 uploadNote">
                            Note: Only images (JPG, JPEG, PNG), PDFs, word documents (DOCX), and excel files (XLSX) are allowed. File size must not exceed 5MB.
                          </div>

                          <div className="uploaded-files mt-2">
                            {(approverMediaFiles[item?.question_id] || []).map((file, index) => (
                              <div key={index} className="file-item">
                                <span className="me-2">{file.name}</span>
                                <MdDeleteOutline
                                  onClick={() => handleRemoveFile(file.url, item?.question_id)}
                                  color="#1f2155"
                                  size={25}
                                  className="remove-icon"
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>)
                    }
                  </div>
                );
              })}
            </>
          )}
      </div>
    </div>
  );
};

export default ApprovalAnswer;
